var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown",class:{'is-expanded': _vm.is.expanded || _vm.expanded},on:{"mouseover":_vm.onMouseEnter,"mouseleave":_vm.onMouseLeave}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }